module.exports = __webpack_public_path__ + "img/shotgun-shell-damage.73e9ca2d.png";